var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoomarkIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2105 10.2684L5.83333 10.049L5.45616 10.2684L0.932736 12.9002C0.871723 12.9176 0.819298 12.9161 0.786069 12.9078C0.767869 12.9033 0.757188 12.8973 0.750965 12.8928C0.750717 12.8926 0.750463 12.8925 0.750202 12.8923C0.750177 12.8902 0.750154 12.888 0.750134 12.8857L0.75 12.8333V2.5C0.75 1.49755 1.49755 0.75 2.5 0.75H9.16667C10.1691 0.75 10.9167 1.49755 10.9167 2.5V12.8333C10.9167 12.8749 10.9098 12.8973 10.9068 12.9052C10.9066 12.9056 10.9065 12.906 10.9063 12.9063C10.906 12.9065 10.9056 12.9066 10.9052 12.9068C10.8973 12.9098 10.8749 12.9167 10.8333 12.9167L10.781 12.9165C10.7732 12.9165 10.7668 12.9164 10.7615 12.9163L6.2105 10.2684Z",
    stroke: "#002145",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomarkIconGray);
export default __webpack_public_path__ + "static/media/boomark_icon_gray.ad0ccb152046793cd5bb7a16c8b1235f.svg";
export { ForwardRef as ReactComponent };